import { checkIfSignificantOtherIsEligible, getSelectionStatusVerb, getChildVsChildren, getEligibleMembersDisplayText, formatAsCurrency, getCoveredMembersDisplayText, getNumEligibleChildren, generateListHtml, } from '../helpers/utilities';
import { variableFunctions as globalVariableFunctions } from './global';
export const variableFunctions = {
    // Verb to use in display text about the user's cancer plan selection.
    selectionStatusVerbDisplayText: (data) => {
        const { selectionStatus } = data.user.cancer;
        return getSelectionStatusVerb(selectionStatus);
    },
    moduleName: (data) => data.user.parabolaModel.storybookModules?.cancer || null,
    recurrenceCoverage: (data) => data.plan.hasRecurrenceCoverage ? data.plan.recurrenceCoverage || '' : '',
    initialDiagnosisPayoutDisplayText: (data) => {
        return data.plan.initialDiagnosisPayout
            ? formatAsCurrency(data.plan.initialDiagnosisPayout)
            : null;
    },
    perProcedureCoverage: (data) => data.plan.perProcedureCoverage || '',
    providedBenefitsPreventive: (data) => data.plan.providedBenefitsPreventive || '',
    lumpSumTiersList: (data) => {
        const numCoverageLevels = Number(data.plan.numCoverageLevels) || 0; // Ensure it's a valid number
        const coverageLevels = [];
        for (let i = 0; i < numCoverageLevels; i++) {
            const key = `level${i + 1}Coverage`;
            const coverageLevel = data.plan[key];
            if (coverageLevel) {
                coverageLevels.push(formatAsCurrency(coverageLevel));
            }
        }
        return generateListHtml(coverageLevels);
    },
    servicesRiderCoverage: (data) => data.plan.hasServicesRider ? data.plan.servicesRiderCoverage || '' : '',
    waitingPeriodDetails: (data) => data.plan.waitingPeriod ? data.plan.waitingPeriodDetails || '' : '',
    maxAgeChildren: (data) => data.plan.maxAgeChildren || null,
    hasEligibleSignificantOther: getHasEligibleSignificantOther,
    eligibleKidsNum: getEligibleKidsNum,
    eligibleChildTerm: (data) => {
        const eligibleKidsNum = getEligibleKidsNum(data);
        return getChildVsChildren(eligibleKidsNum);
    },
    coveredMembersDisplayText: (data) => {
        const { coverKidsNum, coverSpouse } = data.user.cancer;
        const { numKids } = data.user.Global;
        const { spouseTerm } = globalVariableFunctions;
        return getCoveredMembersDisplayText(numKids, coverKidsNum, spouseTerm(data), coverSpouse);
    },
    eligibleMembersDisplayText: (data) => {
        const { numKids } = data.user.Global;
        const eligibleKidsNum = getEligibleKidsNum(data);
        const hasEligibleSignificantOther = getHasEligibleSignificantOther(data);
        const { spouseTerm } = globalVariableFunctions;
        return getEligibleMembersDisplayText(numKids, eligibleKidsNum, spouseTerm(data), hasEligibleSignificantOther);
    },
    carrierName: (data) => data.plan.carrierName || null,
    externalId: (data) => data.plan.externalId || null,
};
function getHasEligibleSignificantOther(data) {
    return checkIfSignificantOtherIsEligible(data.user.Global.spouseType, data.plan.availableToSpousePartner, data.plan.availableToPartner);
}
function getEligibleKidsNum(data) {
    return getNumEligibleChildren(data.user.Global.numKids, data.user.Global.dependents, data.plan.availableToChildren, data.plan.maxAgeChildren);
}
//# sourceMappingURL=cancerInsurance.js.map